import React from 'react'

import { Checkbox, CheckboxProps } from 'semantic-ui-react'

const CustomLabelCheckbox = ({ name, checked, disabled, onClick }: IProps): JSX.Element => (
  <span style={{ float: 'right', marginLeft: '1rem' }}>
    <Checkbox toggle name={name} checked={checked} disabled={disabled} onClick={onClick} />
  </span>
)

interface IProps {
  name: string
  checked: boolean
  disabled?: boolean
  onClick: (event: React.MouseEvent<HTMLInputElement, MouseEvent>, data: CheckboxProps) => void
}

export default CustomLabelCheckbox
